import { persistentAtom } from "@nanostores/persistent";
import { deserialize, serialize } from "wagmi";
import type { ShieldingTxResult } from "../components/shielding/shieldingConfig";
import { LocalStorageKeys } from "./keys";

export const $shieldingTxHistoryAtom = persistentAtom<ShieldingTxResult[]>(LocalStorageKeys.SHIELDING_TX_HIST_KEY, [], {
  encode: serialize,
  decode: deserialize,
});

export function getShieldingTxHistory(): ShieldingTxResult[] {
  return $shieldingTxHistoryAtom.get();
}

export function storeShieldingTx(txData: ShieldingTxResult) {
  const history = $shieldingTxHistoryAtom.get();
  const data = history.concat(txData);
  $shieldingTxHistoryAtom.set(data);
}
